import React from "react";

const Loading = () => {
  return (
    <div className="flex justify-center items-center">
      <div
        className="spinner-border animate-spin inline-block text-sky-500 w-8 h-8 border-4 rounded-full"
        role="status"
      >
        <span className="visually-hidden text-sky-600">...</span>
      </div>
    </div>
  );
};

export default Loading;
